'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import { getFileUploadsErrors } from './getFileUploadsErrors';
import { getThreadId } from '../../threads/operators/threadGetters';
import { threadFromProps } from '../../threads/selectors/threadFromProps';
export const attachmentsErrorForThreadInProps = createSelector([getFileUploadsErrors, threadFromProps], (fileUploadsErrors, thread) => {
  const threadId = getThreadId(thread);
  return get(threadId, fileUploadsErrors) || null;
});